import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { makeLogin } from "../factories/pages";
import { store } from "../../presentation/store";
import Products from "../../presentation/pages/Products";
import { makeReceipts } from "../factories/pages/receipts-factory";
import { Tasks } from "../../presentation/pages/mobile/Tasks";
import { makeCheck } from "../factories/pages/mobile/check-factory";
import { makeCheckReceipts } from "../factories/pages/mobile/check-receipts-factory";
import { makeStore } from "../factories/pages/mobile/store-factory";
import { Receipts } from "../../presentation/pages/Receipts";
import { ReceiptsMain } from "../../presentation/pages/Receipts/Main";
import { makeDbListReceipt } from "../factories/usecases/list-receipts-factory";
import { Separation } from "../../presentation/pages/Separation";
import { SeparationMain } from "../../presentation/pages/Separation/Main";
import { NewPosition } from "../../presentation/pages/Positions/New";
import { makeDbCreatePosition } from "../factories/usecases/create-position-factory";
import { StoreMain } from "../../presentation/pages/mobile/Store/Components/Main";
import { StoreCollector } from "../../presentation/pages/mobile/Store/Components/Collector";
import { StorePositionCollector } from "../../presentation/pages/mobile/Store/Components/PositionCollector";
import { makeDbLoadPositionList } from "../factories/usecases/load-position-list-factory";
import { makeDbStoreItem } from "../factories/usecases/store-item-factory";
import { AddCargo } from "../../presentation/pages/Separation/New";
import { makeDbLoadCargo } from "../factories/usecases/load-cargo-factory";
import { makeDbLoadProductListByManyCodes } from "../factories/usecases/load-product-list-by-many-codes-factory";
import { makeDbSaveCargo } from "../factories/usecases/save-cargo-factory";
import { makeDbLoadNormalizedCargos } from "../factories/usecases/load-normalized-cargos-factory";
import { makeDbDeleteCargo } from "../factories/usecases/delete-cargo-factory";
import { MobileSeparation } from "../../presentation/pages/mobile/Separation";
import { Main } from "../../presentation/pages/mobile/Separation/components/main";
import { CargosOfRoute } from "../../presentation/pages/mobile/Separation/components/cargos-of-route";
import { ItemsOfCargo } from "../../presentation/pages/mobile/Separation/components/items-of-cargo";
import { SeparationPositionCollector } from "../../presentation/pages/mobile/Separation/components/PositionCollector";
import { SeparationProductCollector } from "../../presentation/pages/mobile/Separation/components/product-collector";
import { makeDbSeparateReservation } from "../factories/usecases/separate-reservation-factory";
import { Dashboard } from "../../presentation/pages/Dashboard";
import { MobileTransfer } from "../../presentation/pages/mobile/Transfer";
import { TransferProductCollector } from "../../presentation/pages/mobile/Transfer/components/product-collector";
import { makeDbLoadProductList } from "../factories/usecases/load-product-list-factory";
import { makeValidateTransfer } from "../factories/usecases/validate-transfer-factory";
import { makeDbLoadTransfer } from "../factories/usecases/load-transfer-factory";
import { TransferDestinationCollector } from "../../presentation/pages/mobile/Transfer/components/destination-collector";
import { makeFinishTransfer } from "../factories/usecases/finish-transfer-factory";
import { Main as CheckShipmentByCargoMain } from "../../presentation/pages/mobile/Check/ShipmentsByCargo/Components/Main";
import { CheckShipmentByCargoCollector } from "../../presentation/pages/mobile/Check/ShipmentsByCargo/Components/Collector";
import { CheckShipmentByCargoList } from "../../presentation/pages/mobile/Check/ShipmentsByCargo/Components/List";
import { Report } from "../../presentation/pages/mobile/Check/ShipmentsByCargo/Components/Report";
import Positions from "../../presentation/pages/Positions";
import { makeDbLoadPositionByEan } from "../factories/usecases/load-position-by-ean-factory";
import { makePrivateRoute } from "../factories/pages/private-route-factory";
import { TransferPositionCollector } from "../../presentation/pages/mobile/Transfer/components/position-collector";
import { MobileBreakage } from "../../presentation/pages/mobile/Breakage";
import { BreakagePositionCollector } from "../../presentation/pages/mobile/Breakage/position-collector";
import { BreakageProductCollector } from "../../presentation/pages/mobile/Breakage/product-collector";
import { makeDbCreateBreakageReport } from "../factories/usecases/create-brekage-report-factory";
import { BreakagePage } from "../../presentation/pages/Breakages";
import { makeDbLoadBreakageReport } from "../factories/usecases/load-brekage-report-factory";
import { makeDbDeleteBreakageReport } from "../factories/usecases/delete-brekage-report-factory";
import { makeDbUpdateBreakageReport } from "../factories/usecases/update-brekage-report-factory";
import { Reports } from "../../presentation/pages/Reports";
import ReportsMain from "../../presentation/pages/Reports/Main";
import CheckByProduct from "../../presentation/pages/Reports/CheckByProduct/CheckByProduct";
import { makeDbLoadExternalInventoryByEan } from "../factories/usecases/load-external-inventory-by-ean-factory";
import { makeDbLoadInventoryByEan } from "../factories/usecases/load-inventory-by-ean-factory";
import CheckFullInventory from "../../presentation/pages/Reports/CheckFullInventory/CheckFullInventory";
import { makeDbDeleteReceipt } from "../factories/usecases/delete-receipt-factory";
import AdjustmentsMain from "../../presentation/pages/Adjustments/Main";
import AdjustBatches from "../../presentation/pages/Adjustments/adjust-batch";
import { makeDbUpdateReceiptCheckItem } from "../factories/usecases/update-receipt-check-item-factory";
import AdjustInventory from "../../presentation/pages/Adjustments/adjust-inventory";
import { makeDbUpdateInventory } from "../factories/usecases/update-inventory";
import { MobileAudit } from "../../presentation/pages/mobile/Audit";
import { AuditPositionCollector } from "../../presentation/pages/mobile/Audit/components/position-collector";
import { AuditProductCollector } from "../../presentation/pages/mobile/Audit/components/product-collector";
import { AuditList } from "../../presentation/pages/mobile/Audit/components/list";
import { AuditReport } from "../../presentation/pages/mobile/Audit/components/Report";
import { makeDbAuditPosition } from "../factories/usecases/audit-position-factory";
import LabelPrinter from "../../presentation/pages/Print";
import { MobileInsert } from "../../presentation/pages/mobile/Insert";
import { InsertList } from "../../presentation/pages/mobile/Insert/components/list";
import { InsertProductCollector } from "../../presentation/pages/mobile/Insert/components/product-collector";
import { InsertPositionCollector } from "../../presentation/pages/mobile/Insert/components/position-collector";
import { makeDbInsertInventory } from "../factories/usecases/insert-inventory";
import { makePrintCargoLabel } from "../factories/usecases/print-label/print-cargo-label";
import { CheckShipmentByCargo } from "../../presentation/pages/mobile/Check/ShipmentsByCargo";
import { makeDbCheckCargoById } from "../factories/usecases/check-cargo-by-id-factory";
import { makeDbOverwriteCargo } from "../factories/usecases/overwrite-cargo-factory copy";

export const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={makeLogin()} />
          <Route path="" element={<Dashboard />} />
          <Route
            path="/products"
            element={makePrivateRoute(
              ["admin", "seller"],
              <Products
                loadProducts={makeDbLoadProductList()}
                loadPosition={makeDbLoadPositionByEan()}
              />
            )}
          />
          <Route
            path="/positions"
            element={makePrivateRoute(
              ["admin", "seller"],
              <Positions
                loadPosition={makeDbLoadPositionList()}
                loadProductList={makeDbLoadProductListByManyCodes()}
              />
            )}
          />
          <Route
            path="/positions/new"
            element={makePrivateRoute(
              ["admin"],
              <NewPosition createPosition={makeDbCreatePosition()} />
            )}
          />

          <Route
            path="receipts"
            element={makePrivateRoute(
              ["admin"],
              <Receipts listReceipts={makeDbListReceipt()} />
            )}
          >
            <Route
              path=""
              element={makePrivateRoute(
                ["admin"],
                <ReceiptsMain
                  listReceipts={makeDbListReceipt()}
                  loadProductByManyCodes={makeDbLoadProductListByManyCodes()}
                  deleteReceipt={makeDbDeleteReceipt()}
                />
              )}
            />
            <Route
              path="new"
              element={makePrivateRoute(["admin"], makeReceipts())}
            />
            <Route
              path=":nf"
              element={makePrivateRoute(["admin"], makeReceipts())}
            />
          </Route>

          <Route path="/separation" element={<Separation />}>
            <Route
              path=""
              element={makePrivateRoute(
                ["admin"],
                <SeparationMain
                  loadCargos={makeDbLoadNormalizedCargos()}
                  loadCargo={makeDbLoadCargo()}
                  overwriteCargo={makeDbOverwriteCargo()}
                  loadProducts={makeDbLoadProductListByManyCodes()}
                  deleteCargo={makeDbDeleteCargo()}
                  printCargoLabel={makePrintCargoLabel()}
                />
              )}
            />
            <Route
              path="new"
              element={makePrivateRoute(
                ["admin"],
                <AddCargo
                  loadCargo={makeDbLoadCargo()}
                  loadProductListByManyCodes={makeDbLoadProductListByManyCodes()}
                  saveCargo={makeDbSaveCargo()}
                />
              )}
            />
          </Route>
          <Route
            path="/breakage"
            element={makePrivateRoute(
              ["admin"],
              <BreakagePage
                loadBrakageReports={makeDbLoadBreakageReport()}
                loadProducts={makeDbLoadProductListByManyCodes()}
                deleteBreakage={makeDbDeleteBreakageReport()}
                updateBreakage={makeDbUpdateBreakageReport()}
              />
            )}
          />
          <Route path="/reports" element={<Reports />}>
            <Route
              path="check-by-product"
              element={makePrivateRoute(
                ["admin"],
                <CheckByProduct
                  loadExternalInventory={makeDbLoadExternalInventoryByEan()}
                  loadInventory={makeDbLoadInventoryByEan()}
                />
              )}
            />
            <Route
              path="check"
              element={makePrivateRoute(
                ["admin"],
                <CheckFullInventory
                  loadExternalInventory={makeDbLoadExternalInventoryByEan()}
                  loadInventory={makeDbLoadInventoryByEan()}
                  loadProductsByManyCodes={makeDbLoadProductListByManyCodes()}
                />
              )}
            />
            <Route
              path=""
              element={makePrivateRoute(
                ["admin"],
                <ReportsMain loadInventory={makeDbLoadInventoryByEan()} />
              )}
            />
          </Route>
          <Route path="/adjustments" element={<Reports />}>
            <Route
              path="batch"
              element={makePrivateRoute(
                ["admin"],
                <AdjustBatches
                  loadPosition={makeDbLoadPositionList()}
                  loadProductList={makeDbLoadProductListByManyCodes()}
                  updateReceiptCheckItem={makeDbUpdateReceiptCheckItem()}
                />
              )}
            />
            <Route
              path="inventory"
              element={makePrivateRoute(
                ["admin"],
                <AdjustInventory
                  loadPosition={makeDbLoadPositionList()}
                  loadProductList={makeDbLoadProductListByManyCodes()}
                  updateInventory={makeDbUpdateInventory()}
                />
              )}
            />
            <Route
              path=""
              element={makePrivateRoute(
                ["admin"],
                <AdjustmentsMain loadInventory={makeDbLoadInventoryByEan()} />
              )}
            />
          </Route>
          <Route
            path="/print"
            element={makePrivateRoute(
              ["admin"],
              <LabelPrinter
                loadProducts={makeDbLoadProductList()}
                loadPositions={makeDbLoadPositionList()}
              />
            )}
          />

          <Route
            path="/mobile/tasks"
            element={makePrivateRoute(
              ["admin", "separator", "checker"],
              <Tasks />
            )}
          />
          <Route
            path="/mobile/separation"
            element={makePrivateRoute(
              ["admin", "separator"],
              <MobileSeparation />
            )}
          >
            <Route
              path=""
              element={makePrivateRoute(
                ["admin", "separator"],
                <Main loadCargos={makeDbLoadNormalizedCargos()} />
              )}
            />
            <Route
              path="route"
              element={makePrivateRoute(
                ["admin", "separator"],
                <CargosOfRoute />
              )}
            />
            <Route
              path="items"
              element={makePrivateRoute(
                ["admin", "separator"],
                <ItemsOfCargo
                  loadProductListByManyCodes={makeDbLoadProductListByManyCodes()}
                  loadCargo={makeDbLoadNormalizedCargos()}
                />
              )}
            />
            <Route
              path="position-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <SeparationPositionCollector />
              )}
            />
            <Route
              path="product-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <SeparationProductCollector
                  separateReservation={makeDbSeparateReservation()}
                />
              )}
            />
          </Route>
          <Route
            path="/mobile/check"
            element={makePrivateRoute(
              ["admin", "checker", "separator"],
              makeCheck()
            )}
          />
          <Route
            path="/mobile/check/receipts"
            element={makePrivateRoute(
              ["admin", "checker", "separator"],
              makeCheckReceipts()
            )}
          />
          <Route
            path="/mobile/check/shipments"
            element={makePrivateRoute(
              ["admin", "checker", "separator"],
              <CheckShipmentByCargo />
            )}
          >
            <Route
              path=""
              element={makePrivateRoute(
                ["admin", "checker", "separator"],
                <CheckShipmentByCargoMain
                  loadCargos={makeDbLoadNormalizedCargos()}
                />
              )}
            />
            {/* <Route
              path="cargos"
              element={makePrivateRoute(
                ["admin", "checker", "separator"],
                <CheckShipmentByCargo />
              )}
            /> */}
            <Route
              path="collector"
              element={makePrivateRoute(
                ["admin", "checker", "separator"],
                <CheckShipmentByCargoCollector
                  loadProductList={makeDbLoadProductList()}
                />
              )}
            />
            <Route
              path="list"
              element={makePrivateRoute(
                ["admin", "checker", "separator"],
                <CheckShipmentByCargoList
                  checkCargos={makeDbCheckCargoById()}
                />
              )}
            />
            <Route
              path="report"
              element={makePrivateRoute(
                ["admin", "checker", "separator"],
                <Report />
              )}
            />
          </Route>
          <Route
            path="/mobile/store"
            element={makePrivateRoute(["admin", "separator"], makeStore())}
          >
            <Route
              path=""
              element={makePrivateRoute(["admin", "separator"], <StoreMain />)}
            />
            <Route
              path="collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <StoreCollector />
              )}
            />
            <Route
              path="positionCollector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <StorePositionCollector
                  loadPositionList={makeDbLoadPositionList()}
                  storeItem={makeDbStoreItem()}
                />
              )}
            />
          </Route>
          <Route
            path="/mobile/transfer"
            element={makePrivateRoute(
              ["admin", "separator"],
              <MobileTransfer />
            )}
          >
            <Route
              path="product-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <TransferProductCollector
                  loadProductList={makeDbLoadProductList()}
                  validateTransfer={makeValidateTransfer()}
                />
              )}
            />
            <Route
              path="position-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <TransferPositionCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadTransfer={makeDbLoadTransfer()}
                />
              )}
            />
            <Route
              path="finish"
              element={makePrivateRoute(
                ["admin", "separator"],
                <TransferDestinationCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadProductList={makeDbLoadProductList()}
                  finishTransfer={makeFinishTransfer()}
                  loadTransfer={makeDbLoadTransfer()}
                  deleteCargo={makeDbDeleteCargo()}
                />
              )}
            />
          </Route>
          <Route
            path="/mobile/audit"
            element={makePrivateRoute(["admin", "separator"], <MobileAudit />)}
          >
            <Route
              path="report"
              element={makePrivateRoute(
                ["admin", "separator"],
                <AuditReport
                  loadProductListByManyCodes={makeDbLoadProductListByManyCodes()}
                />
              )}
            />
            <Route
              path="list"
              element={makePrivateRoute(
                ["admin", "separator"],
                <AuditList auditPosition={makeDbAuditPosition()} />
              )}
            />
            <Route
              path="product-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <AuditProductCollector
                  loadProductList={makeDbLoadProductList()}
                />
              )}
            />
            <Route
              path="position-collector"
              element={makePrivateRoute(
                ["admin", "separator"],
                <AuditPositionCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadTransfer={makeDbLoadTransfer()}
                />
              )}
            />
            <Route
              path="finish"
              element={makePrivateRoute(
                ["admin", "separator"],
                <TransferDestinationCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadProductList={makeDbLoadProductList()}
                  finishTransfer={makeFinishTransfer()}
                  loadTransfer={makeDbLoadTransfer()}
                  deleteCargo={makeDbDeleteCargo()}
                />
              )}
            />
          </Route>
          <Route
            path="/mobile/insert"
            element={makePrivateRoute(["admin"], <MobileInsert />)}
          >
            <Route
              path="list"
              element={makePrivateRoute(
                ["admin"],
                <InsertList insertInventory={makeDbInsertInventory()} />
              )}
            />
            <Route
              path="product-collector"
              element={makePrivateRoute(
                ["admin"],
                <InsertProductCollector
                  loadProductList={makeDbLoadProductList()}
                />
              )}
            />
            <Route
              path="position-collector"
              element={makePrivateRoute(
                ["admin"],
                <InsertPositionCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadTransfer={makeDbLoadTransfer()}
                />
              )}
            />
            <Route
              path="finish"
              element={makePrivateRoute(
                ["admin"],
                <TransferDestinationCollector
                  loadPositionList={makeDbLoadPositionList()}
                  loadProductList={makeDbLoadProductList()}
                  finishTransfer={makeFinishTransfer()}
                  loadTransfer={makeDbLoadTransfer()}
                  deleteCargo={makeDbDeleteCargo()}
                />
              )}
            />
          </Route>
          <Route
            path="/mobile/breakage"
            element={makePrivateRoute(
              ["admin", "separator"],
              <MobileBreakage />
            )}
          >
            <Route
              path=""
              element={makePrivateRoute(
                ["admin", "separator"],

                <BreakagePositionCollector
                  loadPositionList={makeDbLoadPositionList()}
                />
              )}
            />
            <Route
              path="product-collector"
              element={makePrivateRoute(
                ["admin", "separator"],

                <BreakageProductCollector
                  loadProductList={makeDbLoadProductList()}
                  createBreakageReport={makeDbCreateBreakageReport()}
                />
              )}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};
